define('payment/handlers/formTemplateHandlers/bankWireTemplateHandler',['jquery'],

    function($) {
        'use strict';

        function changeBank($selectCountries, $bankWireForm) {
            var $emptyBankElement = $bankWireForm.find('.form-group.row.bank.empty');

            var countryId = $selectCountries.find('option:selected').val();
            var $bankElementRows = $bankWireForm.find('.form-group.row.bank');
            $bankElementRows.hide();
            var $bankElement = $bankElementRows.filter('[data-country-id="' + countryId + '"]');
            var $bankInfo = $bankWireForm.find('.bank-info');
            if ($bankElement.length > 0) {
                var bankId = $bankElement.data('bank-id');
                var $bankElements = $bankWireForm.find('[data-bank-id="' + bankId + '"]');
                $bankElements.show();
                $bankInfo.show();
                $emptyBankElement.hide();
            } else {
                $emptyBankElement.show();
                $bankInfo.hide();
            }
        }

        function changeCurrency($selectCountries, $bankWireForm) {
            var $selectedCountry = $selectCountries.find('option:selected');
            var currencyCodesCommaSeparated = $selectedCountry.data('currency-codes');
            var currencyCodes = currencyCodesCommaSeparated.split(',');

            var optionElements = '';
            $.each(currencyCodes, function(index, currencyCode) {
                optionElements += '<option value="' + currencyCode + '">' + currencyCode + '</option>';
            });
            var $selectCurrencies = $bankWireForm.find('.currencies select');
            $selectCurrencies.empty().append(optionElements);
            $selectCurrencies.find('option:first').attr('selected','selected');
        }

        function setupFormTemplate($bankWireForm){
            var $selectCountries = $bankWireForm.find('.countries select');
            changeBank($selectCountries, $bankWireForm);
            changeCurrency($selectCountries, $bankWireForm);

            $selectCountries.off().on('change', function() {
                changeBank($selectCountries, $bankWireForm);
                changeCurrency($selectCountries, $bankWireForm);
            });
        }

        var bankWireTemplateHandler = {};
        bankWireTemplateHandler.setupFormTemplate = setupFormTemplate;

        return bankWireTemplateHandler;
    }
);

